import LoadingScreen from "../LoadingScreen";
import ActivateCare from "./ActivateCare";
import CareBalanceInfo from "./CareBalanceInfo";
import useCareBalance from "./hooks/useCareBalance";

export default function CareBalance({
  history,
  firstName,
  lastName,
  hmoId,
  activeStatusId
}) {
  const { wallet, loading, setLoading } = useCareBalance({
    hmoId,
  });

  if (loading) {
    return <LoadingScreen />;
  }

  if (!wallet) {
    return (
      <ActivateCare
        firstName={firstName}
        lastName={lastName}
        hmoId={hmoId}
        setLoading={setLoading}
        loading={loading}
      />
    );
  }

  return (
    <CareBalanceInfo
      wallet={wallet}
      history={history}
      activeStatusId={activeStatusId}
    />
  );
}
